module.exports = __webpack_public_path__ + "static/media/muscleFront.a99f9a4d.png";